import { motion, useInView } from 'framer-motion';
import { useRef } from 'react';
import styles from './Section.module.css';

export default function Section({ id, eyebrow, title, wide, children }) {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true, amount: 0.15 });

  return (
    <section className={styles.section} id={id} ref={ref}>
      <motion.div
        className={styles.container}
        initial={{ opacity: 0, y: 16 }}
        animate={isInView ? { opacity: 1, y: 0 } : {}}
        transition={{ duration: 0.5 }}
      >
        <div className={styles.eyebrow}>{eyebrow}</div>
        <h2 className={styles.heading}>{title}</h2>
        <div className={wide ? `${styles.body} ${styles.wide}` : styles.body}>{children}</div>
      </motion.div>
    </section>
  );
}
